import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from "i18next-browser-languagedetector";
import { LangService } from "@/service/LangService"

// the translations
// (tip move them in a JSON file and import them)
let resources = {}
let fallbackLngs = []

LangService.map((lang) => {
    fallbackLngs.push(lang.lng)
    resources[lang.lng] = { translation: lang.translation }
    return ""
})

i18n.use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        fallbackLng: fallbackLngs,
        lng: localStorage.getItem('i18nextLngMeLp') || 'mn',
        detection: {
            order: ['cookie', 'querystring',],
            caches: ['cookie'],
        },
        interpolation: {
            escapeValue: false // react already safes from xss
        }
    })

export default i18n
